<template>
<div>
<spinner v-bind:spinner='spinner'></spinner>


<!--
<div class="card border-success">
  <div class="card-header bg-success text-white">

        <h4><i class="far fa-edit mr-2" aria-hidden="true"></i>MODIFICA ESISTENZA PRODOTTO </h4>
    </div>
    <div class="card-body">  
-->

<!-- STOCK TABLE -->
<div class="table-responsive-sm mt-3">              
  <table class="table table-bordered table-sm" id="dataGrid">
    <thead class="thead-light">
      <tr>
        <th 
        class = "text-center"
        v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
         v-for="(key,index) in cols" :key="index">
      <!--    <small  v-if="key!='COLORE'" id="sizeHelp" class="form-text text-muted"><strong>Mis.</strong></small> -->
          <span  >{{key}}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr  v-for="(item, index1) in rows" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
        <div style='color:blue' v-if="key == 'COLORE'" >
        <div class="form-group row">
            <div class="col-6">
                <label for="staticColor" class="col-form-label "><strong>{{item[key].toUpperCase()}}</strong></label>
                 <!--<input  v-model = "item['supplierColor']" class="form-control inputClass" type="text"  :placeholder="'Codice colore fornitore'">-->

            </div>
            <div class="col-1">
                
                <!--<label style="color:grey"  class="col-form-label ">ESISTENZA</label>-->
                <!--<label style="color:#006600" class="col-form-label "><strong>MODIFICA</strong></label>-->

            </div>
            
        </div>
        
        </div> 
         <div v-else>
            <span  class="form-control">{{item[key]['qty']}} </span>   
            <input :disabled="item[key]['row_Id']==0" v-on:keydown="keyHandler($event,'Num')" v-model = "item[key]['update_qty']" class="form-control inputClass" type="number"  :placeholder="''" >
         </div>
        </td>
      </tr>
    </tbody>
  </table>

<!-- Table -->
 </div>
  

  <div class="row ml-2">

 

  

  </div>


<!--
</div>
</div>
-->

  <alert-box class="mt-2 mb-2"  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
    
  <button :disabled="spinner || rows.length==0" @click="saveData()" class="btn btn-primary float-right mr-3">
     <i class="fas fa-edit mr-2" aria-hidden="true"></i>
    MODIFICA
     <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>
 
</div> 
</template>

<script>

import spinner                     from '@/components/common/Spinner.vue';
import alertBox                    from '@/components/common/AlertBox.vue';
import api                         from "@/api"
import { mapGetters }              from 'vuex';
import keyHandler                  from   '@/components/mixins/keyHandler'

export default {
  
   components: {alertBox,spinner},
  props : ['item'],
  mixins: [keyHandler],
  
  data () {
    return {      
    
    items                 : [],
    
    rows                  : [],
    cols                  : [],
   
    supplierColors        : [], 
    total                 : 0,
    
    msg                   : {
      title : ''
    },
    
    

    spinner               : false

    }
  },

  computed: 
  {   
      ...mapGetters(['company']),
  
   
  },

  created()
  {  
    this.getData()
  },

  
  
  
  
  mounted()
  {
    //$('input:visible:enabled:first').focus();      
  },
  methods: 
  {

    //...mapActions(['createStockGrid']),

  
  async saveData()
  {



    this.msg.title = ''
    var items = []
    

    this.rows.forEach(item =>{
        Object.entries(item).forEach(entry => 
            {
                let key = entry[0];
                if (key != 'colorId' && key != 'COLORE' && key != 'supplierColor' )
                {
                    if(Number(entry[1]['update_qty']) != Number(entry[1]['qty']))
                    {
                      items.push({'barcode':entry[1]['barcode'], 'row_Id': entry[1]['row_Id'],'update_qty':Number(entry[1]['update_qty'])})
                    }
                }
                      
            });  
        
      })

    if(items.length==0)
    {
      this.msg.title =  'ATTENZIONE '
      this.msg.body = "Dati non modificati."
      this.msg.type = 1
      return
    }

    

    var data = {}
    data.items = items
    data.data = {'storeId':this.item.storeId,'companyId':this.company.Id}
    this.spinner = true
    
    var sp    = {'sp':'spUpdateStoreStockProductQty'}
    var json  = Object.assign(data, sp);
    

    await api.post(json).then(res => {
          
        
          if(res.status==200)
            {
              this.msg.title = "MODIFICA EFFETTUATA."     
              this.msg.body  = ""
              this.msg.type  = 0
            }
           else if(res.status==500)
           {
              
              this.msg.title = "ATTENZIONE "      
              this.msg.body  = res.data
              this.msg.type  = 1
                
                    
           } 
           else
            {
                

              this.msg.title = "ATTENZIONE "      
              this.msg.body  = res
              this.msg.type  = 1
  

            } 
          

          }).catch(err => {
              
              this.msg.title = "ATTENZIONE "      
              this.msg.body  = err.message
              this.msg.type  = 1
    
              
          }).finally(() => {
          this.spinner = false
        });

    
  },
  




    createGrid(colors,sizes,items)
    {

      this.cols = []
      this.rows = []
      this.cols.push('COLORE')
      sizes.forEach(item =>
      {
        this.cols.push(item.size)
      }) 
             
      var arr = []
      var obj = {}
      var tmp = {}
      
      

      colors.forEach(color => 
      {
        obj  = {}
        obj.COLORE        = color.color
        obj.colorId       = color.colorId
        var colorId       = this.supplierColors.filter(item => (item.colorId == color.colorId))
        obj.supplierColor = colorId.length > 0 ?  colorId[0].supplierColor  : ''        
        sizes.forEach(size => 
        {   

          var item          = items.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId))    

          if(item.length > 0)
          {
            
            tmp = {}    
            tmp['barcode']        = item[0].barcode  
            tmp['row_Id']         = item[0].id
            tmp['qty']            = Number(item[0].qty)                            
            tmp['update_qty']     = item[0].qty
            tmp['sizeId']         = size.sizeId
            tmp['supplierColor']  = item[0].supplierColor
            obj[size.size]        = tmp 

          }
            else
            {
              // SERVE PER RIGA QTY INESISTENTE
              tmp = {}
              tmp['barcode']      = ''
              tmp['row_Id']       = 0
              tmp['qty']          = 0
              tmp['update_qty']   = 0              
              tmp['sizeId']       = size.sizeId
              tmp['supplierColor']  = ''
              obj[size.size]  = tmp 
              
            }

        })
        arr.push(obj)
      })
         
    this.rows = arr
    
   //console.log('DATA',this.rows)

    this.$nextTick(function () {
        $('input:visible:enabled:first').focus(); 
      })            
      
      
    },

   

    async getData()
    {
        this.spinner  = true
        

        var data      = {'storeId' : this.item.storeId, 'productId' : this.item.productId}
        var sp        = {'sp'      : 'spStoreStockProductQty'}
        var json      = Object.assign(data, sp);

       await api.post(json).then(res => {
        

          if(res.status==200)
            {
                var sizes   = res.data.recordsets[1]  
                var colors  = res.data.recordsets[2]
                this.items  = res.data.recordsets[0]
         
                this.supplierColors = []
                    colors.forEach(item => 
                  {
                    this.supplierColors.push({'colorId':item.colorId,'supplierColor':item.supplierColor})  
                  })
        
                this.createGrid(colors,sizes,this.items)
          
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });



        
    },

   
    }
  
}
</script>

<style scoped>
.inputClass{
  font-weight       : bold;
  
  }
.misura
{
  color        : coral;
  font-size    : 12px;
}

input[type=text]:disabled {
  background : white;
  color      : navy
}
h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
</style>